import React from "react";

import { useStoreServiceApi } from "@api/hooks/storeService.hook";
import { StocksResponse } from "@api/hooks/storeService.types";
import { DefaultFor } from "@api/mappers/default.mapper";

import { ProductVisibilityTypes } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { Tooltip } from "@components/General/Tooltip/tooltip.component";

import "./onlyAvailableInStore.scss";

type Props = {
    visibilityType: ProductVisibilityTypes;
    onOpenStorePicker: () => void;
    displayEcommerceText?: boolean;
    sku: string;
};

const OnlyAvailableInStore = ({
    visibilityType,
    onOpenStorePicker,
    displayEcommerceText = true,
    sku,
}: Props) => {
    const { t } = useGranite();
    const toolTipText = t("ecommerce.lookupAvailableStores.tooltip.text");
    const toolTipTitle = t("ecommerce.lookupAvailableStores.tooltip.title");

    const [{ data }] = useStoreServiceApi({
        url: `/stocks/:sku`,
        method: "GET",
        urlParams: {
            sku,
        },
        mapper: DefaultFor<StocksResponse>(),
    });

    return (
        <div>
            {displayEcommerceText && (
                <div className="d-flex">
                    <button
                        className="only-available-in-store btn btn-large btn-outline-primary w-100 disabled"
                        disabled
                        onClick={onOpenStorePicker}
                    >
                        {t(`ecommerce.text.${visibilityType}`)}
                    </button>
                </div>
            )}
            {data?.inStock && (
                <div className="d-flex mt-3">
                    <Button
                        test="onlyAvailableInStore-button-lookupAvailableStores"
                        className={"p-0"}
                        color={"link"}
                        type="button"
                        onClick={onOpenStorePicker}
                    >
                        {t("ecommerce.text.lookupAvailableStores")}
                    </Button>
                    <Tooltip innerHTML={toolTipText} title={toolTipTitle} />
                </div>
            )}
        </div>
    );
};

export default OnlyAvailableInStore;
